import React, { useState } from 'react';
import { Button, ButtonWrapper, Container } from './styled';
import BoxScore from './BoxScore';
import Tracker from './Tracker';

const Tab = ({ detail }) => {
  const [activeTab, setActiveTab] = useState('score');

  const handleChangeActiveTab = (type) => {
    setActiveTab(type);
  };

  const handleClickTrackerButton = () => {
    if (detail.matchTrackerVisible) {
      handleChangeActiveTab('tracker');
    } else {
      alert('상황중계가 제공되지 않는 경기입니다.');
    }
  };
  return (
    <Container>
      <ButtonWrapper>
        <Button
          isActive={activeTab === 'score'}
          onClick={() => handleChangeActiveTab('score')}
        >
          박스 스코어
        </Button>
        <Button
          isActive={activeTab === 'tracker'}
          onClick={handleClickTrackerButton}
        >
          상황중계
        </Button>
      </ButtonWrapper>
      {activeTab === 'score' && <BoxScore detail={detail} />}
      {activeTab === 'tracker' && <Tracker detail={detail} />}
    </Container>
  );
};

export default Tab;
